import styled from 'styled-components';
export const TopRatedListSection = styled.section`
  background: #F1FEFF;
  padding:0px 0 50px 0;
`;

export const TableSection = styled.div`
background: #F9FFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 5px 30px #0000001A;
border-radius: 20px;
table{
  margin-bottom: 0;
}
   td{
    span{
      display:none;
    }
   } 
`;

export const TableRowData = styled.tr``;

export const TableHead = styled.th`
  padding: 17px 30px !important;
  color: #fff !important;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 400;
  white-space: nowrap;
  background:#01606F !important;
  vertical-align: middle;
  &:first-child{
    border-radius: 20px 0px 0px 0px;
  }
  
  &:last-child{
    border-radius: 0px 20px 0px   0px;
  }
`;

export const TableDiv = styled.td`
  padding: 20px 30px !important;
  color: #333333 !important;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: 500;

  cursor: pointer;
  vertical-align: middle;
  .table-btn{
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 0;
    background: transparent;
    border: none;
    display:none;
  }
    p{
        margin-bottom: 0;
    }
`;

export const Tbody = styled.tbody`
    tr:hover {background-color: coral;}
     tr{
      &:last-child{
      td{
        border: none;
        &:first-child{
          border-radius: 0px 0px 0px 20px;
        }
        &:last-child{
          border-radius:0px 0px 20px 0px;
        }
      }
    }
  }
`;
export const Thead = styled.thead``;